import moment from "moment";

export default (val, format = 'yyyy-MM-DD', fallback = '') => {
  const date = moment(val)
  return date.isValid() ? date.format(format) : fallback
}